const ALPHABET_OPTIONS = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
];

// Pre-load skeleton only: the server's filters endpoint returns the same groups
// with per-option disabled states, and buildCoursesFilterGroups swaps to those
// as soon as they arrive.
export const coursesFilterGroups = [
  {
    id: 'alphabet',
    title: 'Alphabet',
    allLabel: 'All',
    options: ALPHABET_OPTIONS,
  },
  {
    id: 'course-types',
    title: 'Course Types',
    allLabel: 'All Course Types',
    options: [
      'Core Studio',
      'Discussion-based Seminar',
      'Independent Study',
      'Lecture',
      'Open Project',
      'Option Studio',
      'Project-based Seminar',
      'Thesis Research',
    ],
  },
  {
    id: 'departments',
    title: 'Departments',
    allLabel: 'All Departments',
    options: [
      'Department of Architecture',
      'Department of Landscape Architecture',
      'Department of Urban Planning and Design',
    ],
  },
];

export function buildCoursesFilterGroups(filters) {
  return Array.isArray(filters?.groups) && filters.groups.length > 0
    ? filters.groups
    : coursesFilterGroups;
}

function explicitSelection(selection) {
  if (!Array.isArray(selection) || selection.includes('all')) return [];

  return selection.map(value => String(value).toLowerCase());
}

function facetValues(facet, groupId) {
  const value = facet?.[groupId];
  const values = Array.isArray(value) ? value : [value];

  return values
    .filter(entry => typeof entry === 'string' && entry !== '')
    .map(entry => entry.toLowerCase());
}

function facetMatches(facet, groupId, selectedIds) {
  const values = facetValues(facet, groupId);

  return selectedIds.some(id => values.includes(id));
}

// Recompute each group's disabled flags from the other groups' selections so
// combinations with no results cannot be picked. A group's own selection is
// ignored for its options (multi-select stays possible), and a selected
// option is never disabled so it can still be unchecked.
export function withFacetDisabledOptions(groups, facets, selectedFilters = {}) {
  if (!Array.isArray(facets) || facets.length === 0) return groups;

  return groups.map(group => {
    const constraints = groups
      .filter(other => other.id !== group.id)
      .map(other => ({ id: other.id, selected: explicitSelection(selectedFilters[other.id]) }))
      .filter(constraint => constraint.selected.length > 0);

    if (constraints.length === 0) return group;

    const reachable = new Set(
      facets
        .filter(facet => constraints.every(({ id, selected }) => facetMatches(facet, id, selected)))
        .flatMap(facet => facetValues(facet, group.id))
    );

    const selectedIds = explicitSelection(selectedFilters[group.id]);

    return {
      ...group,
      options: group.options.map(option => {
        const base =
          typeof option === 'string' ? { id: option, label: option, disabled: false } : option;
        const key = String(base.id).toLowerCase();

        return {
          ...base,
          disabled: selectedIds.includes(key) ? false : base.disabled || !reachable.has(key),
        };
      }),
    };
  });
}
